import { createFileRoute } from '@tanstack/react-router';

import {
  webhookEndpointsQueryOptions,
  webhookEventsQueryOptions,
  WebhooksPage,
} from '@/features/webhooks';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/webhooks/')({
  staticData: { tours: ['settings.webhooks'] },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient
        .query({ ...webhookEndpointsQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({ ...webhookEventsQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]),
  component: WebhooksPage,
});
